/**
 * @generated SignedSource<<8fd8f61a63d5fd1a57e42b19ead79fe8>>
 * @relayHash 84829ba114906eeaccdc963367cfd706
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e6cea5f57876b726dca5d3c1751e175727cf6a5ecb8211bed39e1b55c09df9bc

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AgenticPlanToolInChatQuery$variables = {
  cloudId: string;
  issueKey: string;
};
export type AgenticPlanToolInChatQuery$data = {
  readonly jira: {
    readonly issueByKey: {
      readonly summary: string | null;
      readonly webUrl: AGG$URL | null;
      readonly " $fragmentSpreads": FragmentRefs<"AgenticPlanTool">;
    } | null;
  } | null;
};
export type AgenticPlanToolInChatQuery = {
  response: AgenticPlanToolInChatQuery$data;
  variables: AgenticPlanToolInChatQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "issueKey"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "issueKey"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "summary"
},
v3 = {
  "kind": "ScalarField",
  "name": "webUrl"
},
v4 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "AgenticPlanToolInChatQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "issueByKey",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "FragmentSpread",
                "name": "AgenticPlanTool"
              },
              (v3/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AgenticPlanToolInChatQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "issueByKey",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "name": "key"
              },
              {
                "concreteType": "JiraRichTextField",
                "kind": "LinkedField",
                "name": "descriptionField",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "concreteType": "JiraRichText",
                    "kind": "LinkedField",
                    "name": "richText",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraADF",
                        "kind": "LinkedField",
                        "name": "adfValue",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "json"
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      }
                    ]
                  }
                ]
              },
              (v3/*: any*/),
              (v4/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "e6cea5f57876b726dca5d3c1751e175727cf6a5ecb8211bed39e1b55c09df9bc",
    "metadata": {},
    "name": "AgenticPlanToolInChatQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "cbc3f2cc0ca7d80416a02ad903272bd4";

export default node;
